/**
 * @generated SignedSource<<a8c160252723ad354af42f69f59d9a43>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedYMALItemsCarousel_item$data = {
  readonly serviceId: string | null;
  readonly " $fragmentType": "PdpSharedYMALItemsCarousel_item";
};
export type PdpSharedYMALItemsCarousel_item$key = {
  readonly " $data"?: PdpSharedYMALItemsCarousel_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedYMALItemsCarousel_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedYMALItemsCarousel_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "a26b50cb4868c060ab128f51c7ce680b";

export default node;
